import axiosAuth from '../../axiosPublic';

async function show(id) {
  let response = await axiosAuth.get('/public/category_dashboard_elements/' + id);
  return response.data.data;
}

export default {
  show,
};
